export default "__VITE_PUBLIC_ASSET__c3a5f813__"